import { GaugePreview, PreviewSurface } from './selectorStyles';
import { VOICE_LOUDNESS_COLORS } from './colors';

const VoiceLoudnessSelectorPreview = () => (
  <PreviewSurface>
    <GaugePreview viewBox="0 0 88 76" aria-hidden="true">
      <path d="M 10 60 A 34 34 0 0 1 47 26.1" stroke={VOICE_LOUDNESS_COLORS.TOO_LOW} />
      <path d="M 47 26.1 A 34 34 0 0 1 70 35" stroke={VOICE_LOUDNESS_COLORS.TARGET} />
      <path d="M 70 35 A 34 34 0 0 1 78 60" stroke={VOICE_LOUDNESS_COLORS.TOO_LOUD} />
      <line x1="44" y1="60" x2="34" y2="35" />
      <circle cx="44" cy="60" r="4" />
    </GaugePreview>
  </PreviewSurface>
);

export default VoiceLoudnessSelectorPreview;